// src/components/SongCard.js
import React, { useRef, useContext, useState } from "react";
import { BsMusicNoteList } from "react-icons/bs";

const ItemType = "SONG";

function SongCard({ song, index, handleUpdatePlaylist, handlePlaySong }) {
  const [active, setActive] = useState(song.active);
  const toggleActiveStatus = (e) => {
    e.stopPropagation();
    setActive(!active);
    handleUpdatePlaylist(song, !active);
  };

  return (
    <div
      className={`flex p-2 mb-1 w-full mx-auto cursor-pointer hover:bg-gray-500 ${
        active ? "bg-gray-600" : "bg-gray-800"
      }`}
    >
      <div className="flex-shrink-0" onClick={() => handlePlaySong(song.id)}>
        <img
          src={song.image}
          alt={`${song.title} album cover`}
          className={`max-h-10 w-auto`}
        />
      </div>
      <div
        className={`flex flex-col ml-4 text-left justify-center`}
        onClick={() => handlePlaySong(song.id, active)}
      >
        <div className="flex">
          <div className="text-xs text-gray-100 font-bold">{song.title}</div>
          <div className="text-xs text-gray-100 pl-2 pr-2">|</div>
          <div className="text-xs text-gray-300">{song.band}</div>
        </div>
        <div className="text-[10px] text-gray-400">
          {song.album} - {song.year}
        </div>
      </div>
      <div
        className="flex items-center ml-auto px-2"
        onClick={toggleActiveStatus}
      >
        <BsMusicNoteList
          className={`${active ? "text-white" : "text-red-500"}`}
        />
      </div>
    </div>
  );
}

export default SongCard;
